
import React, { useState, useEffect } from "react";
import Modal from "./common/Modal";
import toast from "react-hot-toast";
// import { toast } from "react-toastify";

const ManageCampaignsModal = ({ contactId, showModal, closeModal }) => {
  const mautic_url = process.env.REACT_APP_CRM_ADMIN;

  const [isLoading, setIsLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [allCampaigns, setAllCampaigns] = useState([]);
  const [activeCampaigns, setActiveCampaigns] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (showModal) {
      setSearchTerm("");
    }
  }, [showModal]);

  // Debounced effect for search term changes
  useEffect(() => {
    if (!showModal) return;

    const debounceTimer = setTimeout(() => {
      fetchCampaigns(searchTerm);
    }, 500); // 500ms debounce delay

    return () => clearTimeout(debounceTimer);
  }, [searchTerm, showModal]);

  const fetchCampaigns = async (search = "") => {
    setIsLoading(true);

    try {
      const url = new URL(`${mautic_url}/api/crm/campaigns`);

      const params = {
        contact_id: contactId,
      };
      if (search) {
        params.search = search;
      }

      const response = await fetch(url.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      });

      if (!response.ok) {
        toast.error("Failed to fetch campaigns");
        setIsLoading(false);
        return;
      }

      const data = await response.json();
      const { all_campaigns, active_campaigns } = data.data;

      setAllCampaigns(all_campaigns || []);
      setActiveCampaigns(active_campaigns.map((campaign) => campaign.id) || []);
    } catch (error) {
      toast.error("Error fetching campaigns: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const handleAddCampaign = async (campaignId) => {
    if (!activeCampaigns.includes(campaignId)) {
      try {
        setSaving(true);
        const url = new URL(`${mautic_url}/api/crm/campaigns/add-contact`);

        const params = {
          contact_id: contactId,
          campaign_id: campaignId,
        };

        const response = await fetch(url.toString(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params),
        });

        if (!response.ok) {
          toast.error("Failed to fetch campaigns");
          setSaving(false);
          return;
        }

        const data = await response.json();
        const { active_campaigns } = data.data;

        // setAllCampaigns(all_campaigns || []);
        setActiveCampaigns(
          active_campaigns.map((campaign) => campaign.id) || []
        );
        toast.success("Campaign added successfully");
      } catch (error) {
        toast.error("Error fetching campaigns: " + error.message);
      } finally {
        setSaving(false);
      }
    }
  };

  const handleRemoveCampaign = async (campaignId) => {
    if (activeCampaigns.includes(campaignId)) {
      try {
        setSaving(true);
        const url = new URL(`${mautic_url}/api/crm/campaigns/remove-contact`);

        const params = {
          contact_id: contactId,
          campaign_id: campaignId,
        };

        const response = await fetch(url.toString(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params),
        });

        if (!response.ok) {
          toast.error("Failed to fetch campaigns");
          setSaving(false);
          return;
        }

        const data = await response.json();
        const { active_campaigns } = data.data;

        // setAllCampaigns(all_campaigns || []);
        setActiveCampaigns(
          active_campaigns.map((campaign) => campaign.id) || []
        );
        toast.success("Campaign removed successfully");
      } catch (error) {
        toast.error("Error fetching campaigns: " + error.message);
      } finally {
        setSaving(false);
      }
    }
  };

  const footer = () => {
    return (
      <React.Fragment>
        <button
          type="button"
          className="cancel-btn"
          onClick={closeModal}
          disabled={saving}
        >
          Cancel
        </button>
        <button
          type="button"
          className="save-btn"
          // onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </React.Fragment>
    );
  };

  return (
    <div id="edit">
      <Modal
        isOpen={showModal}
        onClose={closeModal}
        title={"Manage Campaigns"}
        className="crm"
        // footer={footer()}
      >
        <div className="input-box">
          <label className="input-label" htmlFor="name">
            Search Campaign
          </label>
          <input
            type="text"
            className="form-control"
            placeholder=""
            name="name"
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
        <div className="card scrollable scrollable-y campaigns-list-container">
          {isLoading ? (
            <p>Loading campaigns...</p>
          ) : allCampaigns.length === 0 ? (
            <p>No campaigns found.</p>
          ) : (
            allCampaigns.map((campaign) => (
              <div key={campaign.id} className="campaign-item">
                <span className="campaign-name">{campaign.name}</span>
                <label className="switch m-0">
                  <input
                    type="checkbox"
                    checked={activeCampaigns.includes(campaign.id)}
                    disabled={saving}
                    onChange={() => {
                      if (!activeCampaigns.includes(campaign.id)) {
                        handleAddCampaign(campaign.id);
                      } else {
                        handleRemoveCampaign(campaign.id);
                      }
                    }}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            ))
          )}
        </div>
      </Modal>
    </div>
  );
};

export default ManageCampaignsModal;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/ManageCampaignsModal.js